// extracted by mini-css-extract-plugin
module.exports = {"lds-roller":"FullPageLoader_lds-roller__3KR5F","main":"FullPageLoader_main__30dHY","loading":"FullPageLoader_loading__2d1aB","ellipsis":"FullPageLoader_ellipsis__2L91x"};